"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectedComponent = void 0;
var injected_component_1 = require("./injected-component");
Object.defineProperty(exports, "InjectedComponent", { enumerable: true, get: function () { return injected_component_1.InjectedComponent; } });
//# sourceMappingURL=index.js.map